/**
 * @generated SignedSource<<82df3a98836851ed2da01bf2183491d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContactInfoNudgeQuery$variables = Record<PropertyKey, never>;
export type ContactInfoNudgeQuery$data = {
  readonly me: {
    readonly companyName: string;
    readonly contactInfoNudge: boolean;
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly phone: string;
  };
};
export type ContactInfoNudgeQuery = {
  response: ContactInfoNudgeQuery$data;
  variables: ContactInfoNudgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactInfoNudge",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactInfoNudgeQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContactInfoNudgeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a82fbda10d5ff58b4fd4fbb6a1883940",
    "id": null,
    "metadata": {},
    "name": "ContactInfoNudgeQuery",
    "operationKind": "query",
    "text": "query ContactInfoNudgeQuery {\n  me {\n    id\n    fullName\n    companyName\n    email\n    phone\n    contactInfoNudge\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebd8c4afdd15ba9a9c9aed53b53409a2";

export default node;
